
          import "Search_1azcjuw.linaria.css";
          import React, { forwardRef } from "react";
import { styled } from "@linaria/react";
import Input from "./Base";
import BaseButton from "../Button/Base";
import { SearchIcon, CloseIcon } from "../icons";
const SearchBarWrapper = /*#__PURE__*/styled("div")({
  name: "SearchBarWrapper",
  class: "sij5zx3"
});
const SearchInput = /*#__PURE__*/styled(Input)({
  name: "SearchInput",
  class: "s9ebq6f"
});
const ClearButton = /*#__PURE__*/styled(BaseButton)({
  name: "ClearButton",
  class: "c19f2uzf"
});
const defaultProps = {
  hasIcon: true
};

const Search = ({
  onChange,
  innerRef,
  id,
  value,
  hasIcon,
  ...restProps
}) => {
  const isFieldPopulated = value && value.toString().length > 0 && hasIcon;
  const onClick = onChange;
  return /* @__PURE__ */React.createElement(SearchBarWrapper, null, /* @__PURE__ */React.createElement(SearchInput, {
    id,
    label: "Search",
    onChange,
    type: "search",
    ref: innerRef,
    value,
    ...restProps
  }), hasIcon && /* @__PURE__ */React.createElement(SearchIcon, {
    className: "search__magnifyIcon"
  }), isFieldPopulated && /* @__PURE__ */React.createElement(ClearButton, {
    onClick,
    "aria-label": "Clear Search"
  }, /* @__PURE__ */React.createElement(CloseIcon, null)));
};

Search.defaultProps = defaultProps;
export default forwardRef((props, ref) => /* @__PURE__ */React.createElement(Search, { ...props,
  innerRef: ref
}));
          